import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { IconToggleLabelPlacement, LikeButton } from '..';
import { visualize, story, snap } from 'storybook-snapper';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { likeButtonDriverFactory } from './LikeButton.driver';

class LikeButtonVisual extends React.Component<any> {
  render() {
    return (
      <VisualTestContainer>
        <LikeButton {...this.props} />
        <LikeButton {...this.props} checked />
        <LikeButton {...this.props} disabled checked />
        <LikeButton {...this.props} disabled />
      </VisualTestContainer>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {},
      },
    ],
  },
  {
    describe: 'label',
    its: [
      {
        it: 'default (placement END)',
        props: {
          label: 'Like',
        },
      },
      {
        it: 'placement START',
        props: {
          label: 'Like',
          labelPlacement: IconToggleLabelPlacement.START,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`LikeButton/${describe}`, module).add(it, () => (
      <LikeButtonVisual {...props} />
    ));
  });
});

visualize('LikeButton', () => {
  story('focus', () => {
    const its = ['some label', undefined].map((label) => ({
      it: label ?? 'no label',
      props: { label },
    }));
    its.forEach(({ it, props }) =>
      snap(it, (done) => (
        <VisualAsync
          driverFactory={likeButtonDriverFactory}
          onDone={done}
          action={(driver) => driver.click()}
        >
          <LikeButton checked {...props} />
        </VisualAsync>
      )),
    );
  });
  story('theme variables', () => {
    snap('wst theme', () => (
      <div
        style={
          {
            '--wst-paragraph-2-color-rgb': '220,20,60',
            '--wst-paragraph-2-font-variant': 'small-caps',
            '--wst-paragraph-2-font-style': 'italic',
            '--wst-paragraph-2-font-size': '22px',
            '--wst-paragraph-2-font-family': 'Libre Baskerville',
            '--wst-paragraph-2-font-weight': '900',
          } as React.CSSProperties
        }
      >
        <LikeButton label="Like" />
      </div>
    ));
  });
});
